module.exports = __webpack_public_path__ + "static/CampusPaths-beb5053283922fb4f9f94149d38a8e44.png";